import { DocumentSignerKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { GetDocumentSignBySignerTokenRequest, GetDocumentSignBySignerTokenResponse } from "@maven-rest/docs/DocumentSign.dto";
import { DocumentSignerUrl } from "@maven-rest/docs/DocumentSigner.url";

export function useDocumentSignBySignerTokenQuery(
  req: GetDocumentSignBySignerTokenRequest,
  options?: SimpleQueryOptions<GetDocumentSignBySignerTokenResponse, GetDocumentSignBySignerTokenRequest>
) {
  return useBaseQuery({
    queryKey: [DocumentSignerKey.DocumentSignBySignerToken, req.token, options?.queryKey],
    fnOption: {
      url: DocumentSignerUrl.getDocumentSignBySignerToken(req.token),
      request: req,
    },
    ...options,
  });
}
